import axios from 'axios';
import { CURRENT_API_URL } from "../../Utils/Constants";
import notify from '../../Notifications/ToastifyActions';


function FetchErrorReportsV3Service(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/sellerPartner/FetchErrorReportsV3FromUI`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then( notify.NotifySuccess("Fetching Error Reports."))      
        .then(res => {
            return res.data;
        }).catch(() => {
            notify.NotifyError("An error occurred while Fetching Error Reports.");
            return false;
        });
}

export {
    FetchErrorReportsV3Service,
}